import { 
    LOAD_PERMISSION_DATA_IN_PROGRESS,
    LOAD_ROLE_ADMIN_DATA_SUCCESS,
    LOAD_PERMISSION_DATA_FAILURE, 
    LOAD_PERMISSIONS_DATA_SUCCESS,
    LOAD_ROLE_PERMISSIONS_DATA_SUCCESS,
    PERMISSIONS_OPERATION_COMPLETED
  } from "./actions";
  
  const initialState = { isLoading: false, adminRolesData: [], rolePermissionsData: [], permissionsData:[]};
  
  export const permissionData= (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {    
        
        case LOAD_ROLE_ADMIN_DATA_SUCCESS: {
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            adminRolesData: data,
        };
        }
        case LOAD_PERMISSION_DATA_IN_PROGRESS:
        return {
            ...state,
            isLoading: true,
        };
        case LOAD_PERMISSION_DATA_FAILURE:
        return {
            ...state,
            isLoading: false,
        };
        case LOAD_ROLE_PERMISSIONS_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                rolePermissionsData: data,
            };
        };
        case LOAD_PERMISSIONS_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                permissionsData: data,
            };
            }
        case PERMISSIONS_OPERATION_COMPLETED:
            return {
                ...state,
                isLoading: false,
            };     
        default:
        return state;
    }
  };
  